import { Component } from '../../../../component-decorator';
import { comEsquemaBearer, isKeycloakSession } from '../../../../services/auth/keycloak/keycloak.util';

declare var jQuery;

@Component({
  componentName: 'appColetaColaborador',
  bindings: {
    pedido: '<',
    atualizar: '<',
    mostrarPrevisaoChegadaColaborador: '<',
    showReleaseAlert: '<',
    showAlert: '<',
  },
  template: require('./coleta-colaborador.component.html'),
})
export class ColetaColaboradorComponent implements angular.IController {
  public pedido;
  public atualizar: () => void;
  public showAlert: (msg) => void;

  constructor(private $uibModal, private URLAPICOLETA: string, private localStorageService) {
    'ngInject';
  }

  abrirModalVerificarColaborador() {
    this.$uibModal.open({
      animation: false,
      windowClass: 'modal-release-pick-up',
      template: require('../liberacao-coleta.html'),
      controller: 'ModalLiberacaoColetaController',
    });
  }

  imprimeComprovanteColeta(idPedido) {
    // jQuery.ajax skips both interceptors, so the scheme goes here. It stays synchronous
    // (window.open needs the click), so it cannot wait for a token renewal.
    const token = this.localStorageService.get('token');
    jQuery.ajax({
      url: this.URLAPICOLETA + '/v3/pedido/' + idPedido + '/comprovante/gerar',
      async: false,
      headers: {
        'Authorization': token && isKeycloakSession() ? comEsquemaBearer(token) : token
      },
      type: 'GET',
      success: (pdf) => {
        if (pdf && pdf.length > 0) {
          window.open( pdf, '_blank' );
        } else {
          this.showAlert('Oops... Alguma coisa está errado :)');
        }
      },
      error: () => {
        this.showAlert('Oops... Alguma coisa está errado :)');
      }
    });
  }
}
